
  export default {
    name: `APICredsPopup`,
    props: {
      value: {
        type: Boolean,
        default: false
      },
      clientID: {
        type: String
      },
      clientSecret: {
        type: String
      },
      clientName: {
        type: String
      },
      clientScope: {
        type: String
      }
    },
    computed: {
      visible: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit(`input`, val)
        }
      }
    },
    methods: {
      close() {
        this.visible = false
      }
    }
  }
